import { useSelector } from 'react-redux';
import { LINK_TO_BENTO_WEBSITE } from 'bento-ordering/base/constants/endpoints';

import selectLogoDestinationUrl from 'bento-ordering/base/selectors/selectLogoDestinationUrl';

const useAvatarPath = () => {
  const logoDestinationUrl = useSelector(selectLogoDestinationUrl);
  return logoDestinationUrl || LINK_TO_BENTO_WEBSITE;
};

export default useAvatarPath;
